import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import Row from '../common/layout/row';
import { init } from './erroGeralActions';

import List from './erroGeralList';
import Graph from './erroGeralGraph';

class SelectConfGrupoFisicoErroGeral extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.getConfig('grupo'),
    };
  }

  componentWillMount() {
    this.props.getGrupoFisicoList();
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  handleChange(event) {
    let changed = this.props.getConfig('grupo') !== event.target.value;
    this.setState({ value: event.target.value });
    this.props.setConfig('grupo', event.target.value);
    this.props.setConfig('cont', 0);
    this.props.setConfig('numCont', 0);
    this.props.setConfig('anel', 0);
    this.props.getConfControladorGrupoList(event.target.value);

    if (changed && this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
        <label
          style={{
            fontSize: '13px',
            color: '#475569',
            fontWeight: '600',
            margin: 0,
            paddingRight: '4px',
          }}
        >
          Grupo Físico:
        </label>
        <select
          id={'selectConfGrupoFisicoErroGeral'}
          name={'selectConfGrupoFisicoErroGeral'}
          style={{
            width: '180px',
            height: '38px',
            padding: '7px 10px',
            fontSize: '13px',
            fontWeight: '500',
            border: '1px solid #bfd0e0',
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            color: '#475569',
            boxShadow: 'none',
          }}
          className={'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">Todos</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToPropsGrupo = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToPropsGrupo = dispatch =>
  bindActionCreators(
    {
      getGrupoFisicoList: require('../common/selectdb/selectdbAtions').getGrupoFisicoList,
      getConfControladorGrupoList: require('../common/selectdb/selectdbAtions').getConfControladorGrupoList,
    },
    dispatch,
  );

const SelectConfGrupoFisicoErroGeralConnected = connect(
  mapStateToPropsGrupo,
  mapDispatchToPropsGrupo,
)(SelectConfGrupoFisicoErroGeral);

class SelectConfControladorErroGeral extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.getConfig('cont'),
    };
  }

  componentWillMount() {
    this.props.getConfControladorGrupoList();
  }

  renderOptions() {
    const list = (this.props.list || []).filter(contro => contro.anel === 1);

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numero={contro.numero_controlador}
        data-anel={contro.anel}
        data-latitude={contro.latitude}
        data-longitude={contro.longitude}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
      </option>
    ));
  }

  handleChange(event) {
    let changed = this.props.getConfig('cont') !== event.target.value;
    this.setState({ value: event.target.value });
    this.props.setConfig('cont', event.target.value);
    this.props.setConfig('numCont', event.target.selectedOptions[0].getAttribute('data-numero'));
    this.props.setConfig('anel', event.target.selectedOptions[0].getAttribute('data-anel'));
    this.props.setConfig('contLat', event.target.selectedOptions[0].getAttribute('data-latitude'));
    this.props.setConfig('contLong', event.target.selectedOptions[0].getAttribute('data-longitude'));

    if (changed && this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div className="form-group" style={{ margin: 0 }}>
        <select
          id={'selectConfControladorErroGeral'}
          name={'selectConfControladorErroGeral'}
          style={{
            width: '300px',
            height: '38px',
            padding: '7px 10px',
            fontSize: '13px',
            fontWeight: '500',
            border: '1px solid #bfd0e0',
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            color: '#475569',
            boxShadow: 'none',
          }}
          className={'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">Todos</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToPropsControlador = state => ({ list: state.controladorCad.listConf });
const mapDispatchToPropsControlador = dispatch =>
  bindActionCreators(
    {
      getConfControladorGrupoList: require('../common/selectdb/selectdbAtions').getConfControladorGrupoList,
    },
    dispatch,
  );

const SelectConfControladorErroGeralConnected = connect(
  mapStateToPropsControlador,
  mapDispatchToPropsControlador,
)(SelectConfControladorErroGeral);

class ControladorErroGeral extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshKey: 0,
      isRefreshing: false,
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleListLoaded = this.handleListLoaded.bind(this);
    this.props.init();
  }

  handleFilterChange() {
    this.setState(prevState => ({ refreshKey: prevState.refreshKey + 1, isRefreshing: true }));
  }

  handleListLoaded() {
    if (this.state.isRefreshing) {
      this.setState({ isRefreshing: false });
    }
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <TabHeader label="Gráfico" icon="chart-pie" target="tabGraph" />
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <SelectConfGrupoFisicoErroGeralConnected
                  onChange={this.handleFilterChange}
                  getConfig={require('../configuracao/configLocal').getConfig}
                  setConfig={require('../configuracao/configLocal').setConfig}
                />
                <SelectConfControladorErroGeralConnected
                  onChange={this.handleFilterChange}
                  getConfig={require('../configuracao/configLocal').getConfig}
                  setConfig={require('../configuracao/configLocal').setConfig}
                />
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List
                  key={this.state.refreshKey}
                  forceLoading={this.state.isRefreshing}
                  onDataLoaded={this.handleListLoaded}
                />
              </TabContent>
              <TabContent id="tabGraph">
                <Row>
                  <Graph key={this.state.refreshKey} />
                </Row>
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(ControladorErroGeral);
